// src/state/settings/master/types.ts
var SET_MASTER_SETTINGS = "SET_MASTER_SETTINGS";
var SET_MASTER_SETTINGS_WS = "SET_MASTER_SETTINGS_WS";

export { SET_MASTER_SETTINGS, SET_MASTER_SETTINGS_WS };
